export default __webpack_public_path__ + "static/media/icon-adn.84ceb062.svg";